import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as product from '../actions/product';
import { generateEntities } from '../../core/helpers/entities';
var initialState = {
    error: null,
    ids: [],
    products: {},
    favorites: [],
    selectedProduct: null,
    productOrderHistory: [],
    hasNext: true,
    nextRequestId: null,
    currentPage: 1,
    nextPage: 2,
    totalPages: 1,
    expanding: false,
    loading: false,
    loaded: false,
    onlyInStock: false,
    total: 0,
    productFilters: [],
    productSortOrder: null,
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a;
    var wrap;
    var generatedData;
    switch (action.type) {
        case product.FILTER:
            return tslib_1.__assign({}, state, { ids: [], products: {}, total: null, loading: true, loaded: false });
        case product.FILTER_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { loading: false, loaded: true, ids: generatedData.ids, products: generatedData.entities, selectedProduct: null, currentPage: 1, nextPage: 2, totalPages: generatedData.totalPages, total: generatedData.totalCount });
        case product.FILTER_FAILED:
            return tslib_1.__assign({}, state, { loading: false, loaded: false });
        case product.CLEAR_STATE:
            return Object.assign({}, initialState);
        case product.GET_FAVORITES:
            return tslib_1.__assign({}, state);
        case product.GET_FAVORITES_SUCCESS:
            return tslib_1.__assign({}, state, { favorites: action.payload });
        case product.GET_FAVORITES_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        case product.ADD_FAVORITE:
            return tslib_1.__assign({}, state);
        case product.ADD_FAVORITE_SUCCESS:
            return tslib_1.__assign({}, state, { favorites: state.favorites.concat([action.payload]), loading: false });
        case product.ADD_FAVORITE_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, loading: false });
        case product.REMOVE_FAVORITE:
            return tslib_1.__assign({}, state);
        case product.REMOVE_FAVORITE_SUCCESS:
            var modifiedFavoritesList = state.favorites.slice();
            modifiedFavoritesList.splice(state.favorites.indexOf(state.favorites.find(function (item) { return item.productCode === action.payload; })), 1);
            return tslib_1.__assign({}, state, { favorites: modifiedFavoritesList, loading: false });
        case product.REMOVE_FAVORITE_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload, loading: false });
        case product.EXPAND: {
            if ((state.total === state.ids.length) || !state.total) {
                return tslib_1.__assign({}, state, { expanding: false });
            }
            else {
                return tslib_1.__assign({}, state, { expanding: true });
            }
        }
        case product.EXPAND_SUCCESS:
            wrap = action.payload;
            generatedData = generateEntities(wrap);
            return tslib_1.__assign({}, state, { ids: state.ids.concat(generatedData.ids), products: tslib_1.__assign({}, state.products, generatedData.entities), currentPage: ++state.currentPage, nextPage: ++state.nextPage, expanding: false });
        case product.EXPAND_FAILED:
            return tslib_1.__assign({}, state, { expanding: false });
        case product.SELECT:
            return tslib_1.__assign({}, state, { selectedProduct: action.payload });
        case product.GET_PRODUCT_HISTORY_SUCCESS:
            return tslib_1.__assign({}, state, { productOrderHistory: action.payload });
        case product.GET_PRODUCT_HISTORY_FAILED:
            return tslib_1.__assign({}, state, { error: action.payload });
        case product.ADD:
            return tslib_1.__assign({}, state, { loading: true });
        case product.ADD_SUCCESS:
            var addId = action.payload._id;
            return tslib_1.__assign({}, state, { loading: false, ids: state.ids.concat([addId]), products: tslib_1.__assign({}, state.products, (_a = {}, _a[addId] = action.payload, _a)) });
        case product.ADD_FAILED:
            return tslib_1.__assign({}, state, { loading: false, error: action.payload });
        case product.REMOVE:
            var modifiedProducts = tslib_1.__assign({}, state.products);
            delete modifiedProducts[action.payload];
            var modifiedIds = state.ids.slice();
            modifiedIds.splice(state.ids.indexOf(action.payload), 1);
            return tslib_1.__assign({}, state, { ids: modifiedIds, products: modifiedProducts, total: state.total > 0 ? state.total - 1 : 0 });
        case product.TOGGLE_INSTOCK:
            return tslib_1.__assign({}, state, { onlyInStock: !state.onlyInStock });
        case product.SET_PRODUCT_FILTER:
            var productFilters = state.productFilters;
            if (productFilters.findIndex(function (filterToggleEvent) { return filterToggleEvent.code === action.payload.code; }) > -1) {
                productFilters = state.productFilters.filter(function (filterToggleEvent) { return filterToggleEvent.code !== action.payload.code; });
            }
            else {
                var filterItem = {
                    code: action.payload.code
                };
                productFilters = state.productFilters.concat([filterItem]);
            }
            return tslib_1.__assign({}, state, { productFilters: productFilters });
        case product.SET_PRODUCT_SORT_ORDER:
        case product.SET_PRODUCT_DEFAULT_SORT_ORDER_SUCCESS:
            return tslib_1.__assign({}, state, { productSortOrder: action.payload });
        default:
            return state;
    }
}
export var getProductState = function (state) { return state; };
export var findProducts = function (state) { return state.products; };
export var findIds = function (state) { return state.ids; };
export var findSelectedId = function (state) { return typeof state.selectedProduct === 'string'
    ? state.selectedProduct
    : state && state.selectedProduct && state.selectedProduct._id; };
export var findNextRequestId = function (state) { return state.nextRequestId; };
export var hasNext = function (state) { return state.hasNext; };
export var isLoading = function (state) { return state.loading; };
export var isLoaded = function (state) { return state && state.loaded; };
export var isExpanding = function (state) { return state && state.expanding; };
export var onlyInStock = function (state) { return state.onlyInStock; };
export var total = function (state) { return state.total; };
export var getProductOrderHistory = function (state) { return state.productOrderHistory; };
export var getProductFilters = function (state) { return state.productFilters; };
export var getProductSortOrder = function (state) { return state.productSortOrder; };
export var getSelected = createSelector(findProducts, findSelectedId, function (products, selected) { return products[selected]; });
export var getAll = createSelector(findProducts, findIds, function (products, ids) { return ids.map(function (id) { return products[id]; }); });
export var getProductCount = createSelector(findIds, function (ids) { return ids.length; });
export var getNextPageNumber = createSelector(getProductState, function (state) { return state.nextPage; });
export var getFavorites = createSelector(getProductState, function (state) { return state && state.favorites; });
